import { AppIcon } from "components/AppIcon";
import type { IconName } from "assets/icons";

export default function StatCard({
    label,
    value,
    money = false,
    accent = "blue",
    icon = "bi-bar-chart",
    iconName,
    iconSize = 36,
}: {
    label: string;
    value: number;
    money?: boolean;
    accent?: "blue" | "green" | "mint" | "red" | "orange" | "purple";
    /** Legacy class-based icon (ri-/bi-). Ignored when `iconName` is set. */
    icon?: string;
    /** Custom shared icon registry key (preferred). */
    iconName?: IconName;
    /** Pixel size for custom `iconName` icons. */
    iconSize?: number;
}) {
    const palettes = {
        blue: { bg: "#dbeafe", fg: "#155dfc" },
        green: { bg: "#dcfce7", fg: "#00a63e" },
        mint: { bg: "#EAF9F3", fg: "#22C55E" },
        red: { bg: "#ffe2e2", fg: "#e7000b" },
        orange: { bg: "#fef9c2", fg: "#d08700" },
        purple: { bg: "#f3e8ff", fg: "#9810fa" },
    } as const;
    const { bg, fg } = palettes[accent];

    const display = money
        ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 })
            .format(Number(value || 0))
        : Number(value || 0).toLocaleString();

    return (
        <div className="p-3 bg-white shadow-sm border"
            style={{ borderColor: "#e5e7eb", borderRadius: 12 }}>
            <div className="align-items-center d-flex justify-content-between">
                <div>
                    <div className="small text-muted">{label}</div>
                    <div className="mt-1 fw-bold" style={{ fontSize: 21, color: "#0b1320" }}>
                        {display}
                    </div>
                </div>
                {iconName ? (
                    <span className="d-inline-flex align-items-center justify-content-center">
                        <AppIcon name={iconName} size={iconSize} alt={label} />
                    </span>
                ) : (
                    <span className="d-inline-flex align-items-center justify-content-center"
                        style={{ width: 29, height: 29, borderRadius: 8, background: bg, color: fg }}>
                        <i className={`${icon} fs-16`} />
                    </span>
                )}
            </div>
        </div>
    );
}
